/**
 * Sort direction constants used in API requests
 */
export enum SortDirection {
    ASC  = 'ASC',
    DESC = 'DESC'
}
